<template>
  <div>
    <b-form-group
      :id="$id('moreMenuItemNameFieldset')"
      label-cols="2"
      label="Name"
      label-class="pt-0"
      :label-for="$id('moreMenuItemName')"
      description="The name for this menu item">
      <b-form-input
        :id="$id('moreMenuItemName')"
        v-model="moreMenuItem.name"
        name="name"
        trim />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemPhoneFieldset')"
      label-cols="2"
      label="Display on phone?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemPhone')"
      description="Will this item be displayed on phones?">
      <b-form-checkbox
        :id="$id('moreMenuItemPhone')"
        v-model="moreMenuItem.phone"
        name="phone" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemTabletFieldset')"
      label-cols="2"
      label="Display on tablet?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemTablet')"
      description="Will this item be displayed on tablets?">
      <b-form-checkbox
        :id="$id('moreMenuItemTablet')"
        v-model="moreMenuItem.tablet"
        name="tablet" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemLiteFieldset')"
      label-cols="2"
      label="Display on lite?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemLite')"
      description="Will this item be displayed on lite versions of the application?">
      <b-form-checkbox
        :id="$id('moreMenuItemLite')"
        v-model="moreMenuItem.lite"
        name="lite" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemPaidFieldset')"
      label-cols="2"
      label="Display on paid?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemPaid')"
      description="Will this item be displayed on paid versions of the application?">
      <b-form-checkbox
        :id="$id('moreMenuItemPaid')"
        v-model="moreMenuItem.paid"
        name="paid" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemUrlFieldset')"
      label-cols="2"
      label="Url *"
      label-class="pt-0"
      :label-for="$id('moreMenuItemUrl')"
      description="The url that the menu item links to">
      <b-form-input
        :id="$id('moreMenuItemUrl')"
        v-model="moreMenuItem.url"
        name="url" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemAddAuthorizationHeaderFieldset')"
      label-cols="2"
      label="Add authorization header?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemAddAuthorizationHeader')"
      description="Should the client include the Authorization header when accessing the URL?">
      <b-form-checkbox
        :id="$id('moreMenuItemAddAuthorizationHeader')"
        v-model="moreMenuItem.addAuthorizationHeader"
        name="addAuthorizationHeader" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemLaunchExternallyFieldset')"
      label-cols="2"
      label="Launch Externally?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemLaunchExternally')"
      description="Should the item launch outside of the app?">
      <!-- Options 0,1,2 for webviewtype have been deprecated, now when launchExternally is checked will set webviewtype to launchExternally(3) and unchecked will set to default webview(4) -->
      <b-form-checkbox
        :id="$id('moreMenuItemLaunchExternally')"
        v-model="moreMenuItem.webView"
        :value="LAUNCH_EXTERNALLY_WEBVIEWTYPE"
        :unchecked-value="DEFAULT_WEBVIEWTYPE" /> 
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemAppVersionFieldset')"
      label-cols="2"
      label="App Version"
      label-class="pt-0"
      :label-for="$id('moreMenuItemAppVersion')"
      description="The app version this menu item corresponds to">
      <b-form-input
        :id="$id('moreMenuItemAppVersion')"
        v-model="moreMenuItem.appVersion"
        name="appVersion" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemOSVersionFieldset')"
      label-cols="2"
      label="OS Version"
      label-class="pt-0"
      :label-for="$id('moreMenuItemOSVersion')"
      description="The OS version this menu item corresponds to">
      <b-form-input
        :id="$id('moreMenuItemOSVersion')"
        v-model="moreMenuItem.osVersion"
        name="osVersion" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemEntitlementFieldset')"
      label-cols="2"
      label="Entitlement"
      label-class="pt-0"
      :label-for="$id('moreMenuItemEntitlement')"
      description="The entitlement necessary for this menu item">
      <b-form-input
        :id="$id('moreMenuItemEntitlement')"
        v-model="moreMenuItem.entitlement"
        name="entitlement" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemCanonicalIdFieldset')"
      label-cols="2"
      label="Canonical ID"
      label-class="pt-0"
      :label-for="$id('moreMenuItemCanonicalId')"
      description="The Canonical ID of this menu item">
      <b-form-input
        :id="$id('moreMenuItemCanonicalId')"
        v-model="moreMenuItem.canonicalid"
        name="canonicalid" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemIosFieldset')"
      label-cols="2"
      label="Display on iOS?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemIos')"
      description="Will this item be displayed on iOS?">
      <b-form-checkbox
        :id="$id('moreMenuItemIos')"
        v-model="moreMenuItem.ios"
        name="ios" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemAndroidFieldset')"
      label-cols="2"
      label="Display on Android?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemAndroid')"
      description="Will this item be displayed on Android?">
      <b-form-checkbox
        :id="$id('moreMenuItemAndroid')"
        v-model="moreMenuItem.android"
        name="android" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemScaleToFitFieldset')"
      label-cols="2"
      label="Scale To Fit?"
      label-class="pt-0"
      :label-for="$id('moreMenuItemScaleToFit')"
      description="Should this item scale to fit?">
      <b-form-checkbox
        :id="$id('moreMenuItemScaleToFit')"
        v-model="moreMenuItem.scaleToFit"
        name="scaleToFit" />
    </b-form-group>

    <b-form-group
      :id="$id('moreMenuItemImageFieldset')"
      label-cols="2"
      label="Image"
      label-class="pt-0"
      :label-for="$id('moreMenuItemImageUpload')"
      description="The image attached to the short content">
      <b-input-group>
        <b-form-input
          :id="$id('moreMenuItemImageUpload')"
          v-model="moreMenuItem.imageURL"
          name="imageURL"
          type="url"
          trim />
        <b-input-group-append>
          <b-btn
            variant="outline-primary"
            @click.prevent="$refs.assetUploadModal.show()">
            <i class="fas fa-plus" />
          </b-btn>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-modal
      id="asset-upload"
      ref="assetUploadModal"
      hide-header
      hide-footer
      size="lg">
      <asset-upload
        post-action="/api/client-content/v1/files/static/more-menu-item"
        :existing-files="[]"
        :process-image-cuts="true"
        :constraint="moreMenuItem.constraint"
        @asset-selected-response="onAssetSelect"
        @cancel="$refs.assetUploadModal.hide()" />
    </b-modal>
  </div>
</template>

<script>
import AssetUpload from '@/components/AssetUpload'

export default {
    name: 'MoreMenuItem',
    components: {
        AssetUpload,
    },
    props: {
        value: {
          type: Object,
          required: true,
        },
    },
    data() {
      return {
        LAUNCH_EXTERNALLY_WEBVIEWTYPE: "3",
        DEFAULT_WEBVIEWTYPE: "4",
    }
  },
    computed: {
      CLOUDINARY_ACCOUNT() {
        return process.env.VUE_APP_CLOUDINARY_ACCOUNT
      },
      moreMenuItem() {
        return this.value
      },
    },
    methods: {
        onAssetSelect(response) {
            this.$refs.assetUploadModal.hide()

            if (response.url) {
                this.emitFieldUpdate({
                    target: {
                        name: 'imageURL',
                        value: response.url,
                    },
                })
            } else {
                console.warn('Ignoring invalid asset selection')
            }
        },
        emitFieldUpdate(event, truthy, falsy) {
            const value = (() => {
              if (event.target.type === 'checkbox') {
                return event.target.checked ? truthy : falsy
              }

              return event.target.value
            })()

            this.$emit("field-update", {
                id: this.id,
                field: event.target.name,
                value,
            })
        },
    },
}
</script>
